import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export interface ProductCategoryTransaction {
  resource: string;
  method: string;
  id: string;
  data: {
    product_category_id?: number[];
    asset_id?: number[];
    theme_id?: number[];
    narrative?: string;
  };
}

export const useUpdateProductsCategory = () => {
  return useMutation({
    mutationFn: updateProductCategories,
    onSettled: () => {
      queryClient.invalidateQueries(queryKeys.products.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.productCategories.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.productVariationTypes.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.viewProductCategoriesWithProducts.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.productPublications.invalidateAll(),
      );
    },
  });
};

async function updateProductCategories(payload: ProductCategoryTransaction[]) {
  const response = await requestCCApi({
    url: `/transaction`,
    method: 'POST',
    data: {
      data: payload,
    },
  });

  return response.data;
}
